import { PageHeader } from "~/components/PageHeader";
import { ScrollArea } from "~/components/ui/scroll-area";
import { CatalogOverviewSidebar } from "../CatalogOverviewSidebar";
import { ReferenceData } from "~/modules/reference_data/types";
import { Measure } from "~/modules/measures/types";
import { CatalogIcon } from "../CatalogIcon";

interface CatalogIndividualLayoutProps {
    title: string;
    icon?: string;
    color?: string;
    shortDescription?: string | null;
    description: string | null;
    measures: Measure[];
    referenceData: ReferenceData[];
    children: React.ReactNode;
}

export function CatalogIndividualLayout({
    title,
    icon,
    color,
    shortDescription,
    description,
    measures,
    referenceData,
    children,
}: CatalogIndividualLayoutProps) {
    const iconEl = <CatalogIcon icon={icon} color={color} size="lg" />;

    return (
        <div className="flex flex-col h-[calc(100vh-theme(spacing.breadcrumbs-height))] overflow-hidden">
            <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <div className="flex h-full min-h-0 overflow-hidden">
                    <CatalogOverviewSidebar
                        measures={measures}
                        referenceData={referenceData}
                    />

                    <ScrollArea className="flex-1 min-h-0 min-w-0 overflow-hidden">
                        <article className="flex-1 min-w-0 flex flex-col pt-2 pb-8 px-6">
                            <PageHeader
                                title={title}
                                subtitle={shortDescription}
                                icon={iconEl}
                            />

                            {description &&
                                description !== shortDescription && (
                                    <p className="font-sans font-light text-sm leading-normal mb-6 text-slate-600 md:max-w-3xl inline-block">
                                        {description}
                                    </p>
                                )}
                            {children}
                        </article>
                    </ScrollArea>
                </div>
            </div>
        </div>
    );
}
